/**
 * /dl — 스마트 다운로드 리다이렉트.
 * QR 코드를 폰으로 스캔해 열면 이 페이지가 기기 OS를 보고 알맞은 스토어로 보낸다.
 * (PC에서 직접 열리면 랜딩 다운로드 섹션으로)
 */
import { useEffect } from 'react';
import { mobileStoreUrl } from '../../config/storeLinks';

const DownloadRedirectPage = () => {
  useEffect(() => {
    const store = mobileStoreUrl();
    window.location.replace(store || '/intro#download');
  }, []);
  return null;
};

export default DownloadRedirectPage;
